import cookieManager from "../../../../utils/cookieManager";
import axios from "axios";
import TakingGoodsActions from "../../../../reducers/modules/warehouse/taking-goods/actions";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Navigate } from "react-router-dom";

const MySwal = withReactContent(Swal);
const url = process.env.REST_URL + "warehouse/taking-goods";

export default class TakingGoodsMiddleware {
  static create(params) {
    return (dispatch) => {
      dispatch(TakingGoodsActions.create());
      TakingGoodsMiddleware.showHelperFull(dispatch, params);
    };
  }

  static update(params) {
    return (dispatch) => {
      dispatch(TakingGoodsActions.update());
      // TakingGoodsMiddleware.showHelperFull(dispatch, params);
      TakingGoodsMiddleware.showOne(dispatch, params);
    };
  }

  static return(params) {
    return (dispatch) => {
      dispatch(TakingGoodsActions.return());
      // TakingGoodsMiddleware.showHelperFull(dispatch, params);
      TakingGoodsMiddleware.showOneData(dispatch, params);
    };
  }

  static viewItem(params) {
    return (dispatch) => {
      dispatch(TakingGoodsActions.viewItem());
      // TakingGoodsMiddleware.showHelperFull(dispatch, params);
      TakingGoodsMiddleware.showOneView(dispatch, params);
    };
  }

  static list(params) {
    return (dispatch) => {
      dispatch(TakingGoodsActions.process());
      TakingGoodsMiddleware.showlist(dispatch, params);
    };
  }
  static reset() {
    return (dispatch) => {
      dispatch(TakingGoodsActions.reset());
    };
  }

  static getPrint(params) {
    return (dispatch) => {
      dispatch(TakingGoodsActions.beforePrint());
      TakingGoodsMiddleware.showPrint(dispatch, params);
    };
  }

  static resetList() {
    return (dispatch) => {
      dispatch(TakingGoodsActions.resetList());
    };
  }
  static getOne(params) {
    return (dispatch) => {
      dispatch(TakingGoodsActions.view());
      TakingGoodsMiddleware.showOne(dispatch, params);
    };
  }


  static beforeSaveNew(post, search) {
    return (dispatch) => {
      dispatch(TakingGoodsActions.submit());
      TakingGoodsMiddleware.saveNew(dispatch, post, search);
    };
  }

  static beforeSaveReturn(post, search) {
    return (dispatch) => {
      dispatch(TakingGoodsActions.submit());
      TakingGoodsMiddleware.saveReturn(dispatch, post, search);
    };
  }

  static beforeSaveUpdate(params, post, search) {
    return (dispatch) => {
      dispatch(TakingGoodsActions.submit());
      TakingGoodsMiddleware.saveUpdate(dispatch, params, post, search);
    };
  }
  static beforeDelete(id, params) {
    return (dispatch) => {
      dispatch(TakingGoodsActions.delete());
      TakingGoodsMiddleware.delete(dispatch, params, id);
    };
  }

  static getToken() {
    return cookieManager.getUserToken();
  }
  static getHelperFull(params = null) {
    return (dispatch) => {
      TakingGoodsMiddleware.showHelperFull(dispatch, params);
    };
  }

  static showHelperFull(dispatch, params, date) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${TakingGoodsMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "helper/get-taking-goods-helper",
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(TakingGoodsActions.helperFull(response.data.result));
        }
      })
      .catch((error) => {
        TakingGoodsMiddleware.alertHendler(dispatch, error);
      });
  }

  static showPrint(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${TakingGoodsMiddleware.getToken()}`,
      },
      url: url + "/print/" + params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(TakingGoodsActions.print(response.data.result));
        }
      })
      .catch((error) => {
        TakingGoodsMiddleware.alertHendler(dispatch, error);
      });
  }


  static showlist(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${TakingGoodsMiddleware.getToken()}`,
      },
      url: url,
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(TakingGoodsActions.list(response.data.result));
        }
      })
      .catch((error) => {
        TakingGoodsMiddleware.alertHendler(dispatch, error);
      });
  }

  static showOne(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${TakingGoodsMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(TakingGoodsActions.view(response.data.result));
        }
      })
      .catch((error) => {
        TakingGoodsMiddleware.alertHendler(dispatch, error);
      });
  }

  static showOneData(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${TakingGoodsMiddleware.getToken()}`,
      },
      url: url + "/return/" + params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(TakingGoodsActions.view(response.data.result));
        }
      })
      .catch((error) => {
        TakingGoodsMiddleware.alertHendler(dispatch, error);
      });
  }

  static showOneView(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${TakingGoodsMiddleware.getToken()}`,
      },
      url: url + "/view-item/" + params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(TakingGoodsActions.view(response.data.result));
        }
      })
      .catch((error) => {
        TakingGoodsMiddleware.alertHendler(dispatch, error);
      });
  }

  static delete(dispatch, params, id) {
    axios({
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${TakingGoodsMiddleware.getToken()}`,
      },
      url: url + "/" + id,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            TakingGoodsActions.process(),
            TakingGoodsMiddleware.showlist(dispatch, params)
          );
          TakingGoodsMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Delete Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        TakingGoodsMiddleware.alertHendler(dispatch, error, true);
      });
  }

  static saveNew(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${TakingGoodsMiddleware.getToken()}`,
      },
      url: url,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            TakingGoodsActions.process(),
            TakingGoodsMiddleware.showlist(dispatch, search)
          );
          dispatch(TakingGoodsActions.success());
          TakingGoodsMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Create Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        TakingGoodsMiddleware.alertHendler(dispatch, error);
      });
  }

  static saveReturn(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${TakingGoodsMiddleware.getToken()}`,
      },
      url: url+'/save-return',
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            TakingGoodsActions.process(),
            TakingGoodsMiddleware.showlist(dispatch, search)
          );
          dispatch(TakingGoodsActions.success());
          TakingGoodsMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Return Taking Goods Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        TakingGoodsMiddleware.alertHendler(dispatch, error);
      });
  }

  static saveUpdate(dispatch, params, post, search) {
    axios({
      method: "PUT",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${TakingGoodsMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            TakingGoodsActions.process(),
            TakingGoodsMiddleware.showlist(dispatch, search)
          );
          dispatch(TakingGoodsActions.success());
          TakingGoodsMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Update Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        TakingGoodsMiddleware.alertHendler(dispatch, error);
      });
  }

  static beforeApprove(id, value, search) {
    const post = {
      id: id,
      value: value,
    };
    return (dispatch) => {
      dispatch(TakingGoodsActions.approve());
      TakingGoodsMiddleware.saveApprove(dispatch, post, search);
    };
  }
  static beforeReject(id, value, search) {
    const post = {
      id: id,
      value: value,
    };
    return (dispatch) => {
      dispatch(TakingGoodsActions.reject());
      TakingGoodsMiddleware.saveReject(dispatch, post, search);
    };
  }

  static saveApprove(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${TakingGoodsMiddleware.getToken()}`,
      },
      url: url + "/approve/" + post.id,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            TakingGoodsActions.process(),
            TakingGoodsMiddleware.showlist(dispatch, search)
          );
          dispatch(TakingGoodsActions.success());
          TakingGoodsMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Approve Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        TakingGoodsMiddleware.alertHendler(dispatch, error, true);
      });
  }
  static saveReject(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${TakingGoodsMiddleware.getToken()}`,
      },
      url: url + "/reject/" + post.id,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            TakingGoodsActions.process(),
            TakingGoodsMiddleware.showlist(dispatch, search)
          );
          dispatch(TakingGoodsActions.success());
          TakingGoodsMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Reject Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        TakingGoodsMiddleware.alertHendler(dispatch, error, true);
      });
  }



  static alertHendler(
    dispatch,
    result,
    isSwal = false,
    extraMessage = "",
    type = "error"
  ) {
    if (type == "error") {
      if (result.response) {
        const status = result.response.status;
        switch (status) {
          case 500:
            if (isSwal) {
              const data = result.response.data;
              MySwal.hideLoading();
              MySwal.update({
                title: "Delete Error",
                html: data.error,
                icon: "error",
                showConfirmButton: true,
              });
            } else {
              const data = result.response.data;
              dispatch(TakingGoodsActions.error(data.error));
            }
            break;
          case 403:
            console.log("Error 403");
            break;
          case 404:
            console.log("Error 404");
            break;
          case 401:
            const data = result.response.data;
            MySwal.fire({
              title: "Login Invalid",
              html: data.error,
              icon: "error",
              showConfirmButton: true,
            }).then((result) => {
              if (result.isConfirmed) {
                <Navigate to="/login"></Navigate>;
              }
            });
            break;
        }
      } else if (result.request) {
        MySwal.fire({
          title: "Internal Server Error",
          html: "Please info your Developer to fix this",
          icon: "error",
          showConfirmButton: true,
        });
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", result.message);
      }
    } else {
      MySwal.fire({
        title: "Success",
        html: extraMessage,
        icon: "success",
        showConfirmButton: true,
      });
    }
  }
}
